var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-component',{attrs:{"label":"Términos y Condiciones","button-label":"Cerrar","show":_vm.show,"terms":true},on:{"close":_vm.onClose,"aceptar":_vm.onClose}},[_c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"no-border",attrs:{"title":"Términos y Condiciones","src":_vm.terms}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }